import { render } from "./B2bTableReportesEmitidos.vue?vue&type=template&id=60a285b2&scoped=true&lang=pug"
import script from "./B2bTableReportesEmitidos.vue?vue&type=script&lang=js"
export * from "./B2bTableReportesEmitidos.vue?vue&type=script&lang=js"

import "./B2bTableReportesEmitidos.vue?vue&type=style&index=0&id=60a285b2&lang=scss&scoped=true"
import "./B2bTableReportesEmitidos.vue?vue&type=style&index=1&id=60a285b2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a285b2"]])

export default __exports__